import DateFilter from '@/components/date-filter';
import $ from 'jquery'
import store_article from "@/store/mods/stock/articles"

export default {
    name: "historique-destockage",
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            fields: [
                { key: 'article', label: 'Article' },
                { key: 'initial', label: 'Initial' },
                { key: 'qte_sortie', label: 'Qté sortie' },
                { key: 'date', label: 'Date' },
            ],
            filter: "",
            perPage: 25,
            currentPage: 1,
            is_empty: false,
            user_role: "",

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',
            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            historique_destockages: [],
            is_loading: true,
            load_error: false,
            is_month: false,
        };
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.current_date_filter = data
            this.getListeDestockage(data)
            this.is_month = true
        },
    },

    computed: {
        liste_historique_destockage() {
            return this.$store.getters["liste_historique_destockage"];
        },

        len_destockage() {
            return this.liste_historique_destockage.length
        },

        activeRole() {
            return this.$store.getters["activeRole"];
        },
    },

    mounted() {
        const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: ""
        }
        this.current_date_filter = data
        this.getListeDestockage(data)

        // if (this.activeRole.nom != "ROLE_ADMINISTRATEUR") {
        //     if (this.activeRole.nom == "ROLE_PHARMACIEN") {
        //         this.$router.push({ path: "/stock" });
        //     } else if (this.activeRole.nom == "ROLE_PHARMACIEN_INTERMITENT") {
        //         this.$router.push({ path: "/ventes" });
        //     }
        // }
    },

    methods: {
        getListeDestockage(data) {
            this.is_loading = true

            store_article.getDestockageListe(data).then((response) => {
                this.historique_destockages = response

                if (this.historique_destockages.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false 
            }).catch(() => {
                this.is_loading = false
                this.load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getListeDestockage(data)
            this.is_month = false
        },
    },
};
